export const superScriptChars = ['®', '§'];
